import { gql } from 'graphql-request'
import { fragmentMediaQuery } from '../fragments/media'

export const ManyProgrammeTypesQuery = gql`
  query AllProgrammeTypes(
    $locale: LocaleInputType!
    $isPreview: Boolean! = false
    $statuses: [ProgrammeType__status_Input] = [published]
  ) {
    ProgrammeTypes(
      draft: $isPreview
      limit: 100
      locale: $locale
      sort: "_order"
      where: { _status: { in: $statuses } }
    ) {
      docs {
        id
        title
        slug
        type
      }
      totalDocs
    }
  }
`

export const ManyProgrammesByTypeQuery = gql`
  query AllProgrammesByType(
    $typeId: JSON
    $locale: LocaleInputType!
  ) {
    Programmes(
      limit: 200
      locale: $locale
      sort: "recurrences__dateTimeStart"
      where: { type: { equals: $typeId }, _status: { equals: published } }
    ) {
      docs {
        id
        title
        slug
        image ${fragmentMediaQuery}
        description
        type {
          slug
          type
        }
        recurrences {
          dateTimeStart
          dateTimeEnd
          id
        }
        content {
          __typename
        }
      }
      totalDocs
      hasNextPage
    }
  }
`

export const ManyCurrentAndUpcomingOccurrencesByTypeQuery = gql`
  query CurrentAndUpcomingOccurrencesByType(
    $now: DateTime!
    $typeId: JSON
    $locale: LocaleInputType!
    $page: Int = 1
    $limit: Int = 100
  ) {
    ProgrammeOccurrences(
      page: $page
      limit: $limit
      locale: $locale
      sort: "dateTimeStart"
      where: {
        AND: [
          { _status: { equals: published } }
          { dateTimeEnd: { greater_than_equal: $now } }
          { type: { equals: $typeId } }
        ]
      }
    ) {
      docs {
        id
        title
        dateTimeStart
        dateTimeEnd
        programme {
          slug
          _status
          image ${fragmentMediaQuery}
          description
        }
      }
      hasNextPage
    }
  }
`

export const ManyPastOccurrencesByTypeQuery = gql`
  query PastOccurrencesByType(
    $now: DateTime!
    $typeId: JSON
    $locale: LocaleInputType!
    $page: Int = 1
    $limit: Int = 100
  ) {
    ProgrammeOccurrences(
      page: $page
      limit: $limit
      locale: $locale
      sort: "-dateTimeStart"
      where: {
        AND: [
          { _status: { equals: published } }
          { dateTimeEnd: { less_than: $now } }
          { type: { equals: $typeId } }
        ]
      }
    ) {
      docs {
        id
        title
        dateTimeStart
        dateTimeEnd
        programme {
          slug
          _status
          image ${fragmentMediaQuery}
          description
        }
      }
      hasNextPage
    }
  }
`
